import { useState } from "react";

export type AccordionIndex = number | string | undefined;

export function useAccordion(
    defaultIndex?: AccordionIndex
): [AccordionIndex, (index: AccordionIndex) => void] {
    const [activeIndex, setActiveIndex] = useState<AccordionIndex>(defaultIndex);

    const toggleActiveIndex = (index: AccordionIndex) => {
        if (activeIndex === index) {
            return setActiveIndex(undefined);
        }
        setActiveIndex(index);
    };

    return [activeIndex, toggleActiveIndex];
}
